import React from "react";
import ConfigurationContent from "./components/configuration-content";

const Configuration = (props) => <ConfigurationContent {...props} />;

export default Configuration;
